import { render } from "./contentView.vue?vue&type=template&id=3566b51c&scoped=true"
const script = {}

import "./contentView.vue?vue&type=style&index=0&id=3566b51c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3566b51c"]])

export default __exports__